import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	() =>
		createStyles({
			rootNonData: {
				position: "absolute",
				left: "50%",
				top: "50%",
				transform: "translate(-50%, -50%)"
			}
		}),
	{
		name: "NoneData",
		index: 1
	}
);

export default useStyles;
